/* eslint-disable complexity */
/* eslint-disable no-magic-numbers */
import clsx from 'clsx';
import React, { useRef, useLayoutEffect } from 'react';

import { ReportIntlProvider } from '../report-intl-provider/report-intl-provider';
import { ReportRenderer } from '../report-renderer/report-renderer';
import { ReportTitle } from '../report-title/report-title';
import { useNavHeight } from '../../../hooks/useNavHeight';
import { useReportBuilderContext } from '../../report-builder.context';

import styles from './report-view.scss';

export const TemplateView = () => {
  const {
    pageSetup: { orientation, backgroundColor },
    setWorkAreaWidth,
    locale
  } = useReportBuilderContext();
  const { navHeight } = useNavHeight();
  const workAreaRef = useRef<HTMLDivElement | null>(null);
  const workAreaHeight = `calc(100vh - ${navHeight}px)`;

  useLayoutEffect(() => {
    const updateWorkAreaWidth = () => {
      setWorkAreaWidth((workAreaRef.current?.clientWidth || 120) - 120);
    };
    updateWorkAreaWidth();

    window.addEventListener('resize', updateWorkAreaWidth);

    return () => {
      window.removeEventListener('resize', updateWorkAreaWidth);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workAreaRef.current?.clientWidth]);

  return (
    <div
      className={clsx(styles.viewContainer, styles.withNoSidebar)}
      id="viewContainer"
      style={{ height: workAreaHeight, ...(orientation === 'dashboard' ? { backgroundColor } : {}) }}
      ref={workAreaRef}
    >
      <ReportIntlProvider locale={locale}>
        <ReportTitle />
        <ReportRenderer isDashboard={orientation === 'dashboard'} containerRef={workAreaRef} />
      </ReportIntlProvider>
    </div>
  );
};
